import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { purgeSession } from './lib/firebase';
// Inter auto-hospedada: substituta da SF Pro em Windows/Android, empacotada
// junto do app para que o PWA mantenha a tipografia offline.
import '@fontsource-variable/inter';
import './styles.css';

// Versões anteriores gravavam perfil e respostas da API no storage do
// navegador. Apaga esses resíduos antes de qualquer render.
purgeSession();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// Dissolve o splash do index.html assim que o React tem algo para mostrar.
requestAnimationFrame(() => {
  const boot = document.getElementById('boot');
  if (!boot) return;
  boot.classList.add('done');
  boot.addEventListener('transitionend', () => boot.remove(), { once: true });
  setTimeout(() => boot.remove(), 600);
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Uma versão nova assume o controle na próxima navegação, sem exigir
        // que o operador feche o app.
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              installing.postMessage('SKIP_WAITING');
            }
          });
        });
      })
      .catch(() => {
        /* PWA opcional — falha silenciosa em dev/preview */
      });
  });
}
